import React from 'react';
import { useHistory } from "react-router-dom";
import { useState, useEffect } from 'react';
import ls from 'local-storage';
import ManageAccountLinks from "../../Component/ManageAccountLinks/ManageAccountLinks"
import API from "../../Services/BaseService";
import Popup from '../../Component/Popup/Popup';
import '../../Component/Popup/popup.css';
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import { Button, Upload } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import Loading from "../../Component/Loading/Loading";
import DealerAction from '../DealerRedux/DealerAction';
import PageNotFound from '../FallBackUI/PageNotFound';

const { Dragger } = Upload;

const Document = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [docList, setDocList] = useState("");
    const [buyerDocList, setBuyerDocList] = useState("");
    const [flagFilter, setFalgFilter] = useState(false);
    const dealerData = useSelector(state => state.DealerReducer.payload);
    const [dealerList, setDealerList] = useState("");
    const [dealerId, setDealerId] = useState("");
    const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
    const [selectSellerId, setselectSellerid] = useState("");

    const [doc1, setDoc1] = useState("");
    const [doc2, setDoc2] = useState("");
    const [doc3, setDoc3] = useState("");
    const [doc4, setDoc4] = useState("");
    const [doc5, setDoc5] = useState("");
    const [doc6, setDoc6] = useState("");
    const [doc7, setDoc7] = useState("");
    const [doc8, setDoc8] = useState("");
    const [doc9, setDoc9] = useState("");
    const [doc10, setDoc10] = useState("");
    const [doc11, setDoc11] = useState("");
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("")
    const [Type, setType] = useState("");
    const [UpdateType, setUpdateType] = useState("");
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }
    const successData = useSelector(state => state.LoginReducer.payload);
    async function getDocuments(data) {
        console.log("inside get document");
        let request = {
            // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data,
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        };
        const state = API.post('seller_document/condition', request);
        state.then(res => {

            if (res.data.success === true) {
                let document = res.data.data;
                console.log("====document====>", document)
                for (let x in document) {
                    if (document[x].seller_doc_type_id === 1) {
                        setDoc1(document[x])
                    }
                    else if (document[x].seller_doc_type_id === 2) {
                        setDoc2(document[x])
                    } else if (document[x].seller_doc_type_id === 3) {
                        setDoc3(document[x])
                    } else if (document[x].seller_doc_type_id === 4) {
                        setDoc4(document[x])
                    } else if (document[x].seller_doc_type_id === 5) {
                        setDoc5(document[x])
                    } else if (document[x].seller_doc_type_id === 6) {
                        setDoc6(document[x])
                    } else if (document[x].seller_doc_type_id === 7) {
                        setDoc7(document[x])
                    } else if (document[x].seller_doc_type_id === 8) {
                        setDoc8(document[x])
                    } else if (document[x].seller_doc_type_id === 9) {
                        setDoc9(document[x])
                    } else if (document[x].seller_doc_type_id === 10) {
                        setDoc10(document[x])
                    } else if (document[x].seller_doc_type_id === 11) {
                        setDoc11(document[x])
                    }
                }
                setDocList(res.data.data);
                setLoading(false);
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);
                }
            });

    }

    useEffect(() => {
        getDocuments(dealerData);
        sellerDocument(dealerData);
        getDealername();
    }, [dealerData]);


    const deleteFileConfirmation = (document_id, value, name, oldValue) => {
        // console.log("document_id====",document_id)
        localStorage.setItem("deletDocumentId", document_id)
        localStorage.setItem("deletDocumentName", name)
        localStorage.setItem("deletDocumentValue", oldValue)
        togglePopup()
        setPopupTitle("Document Delete");
        setPopupMsg("Are you sure, You want to delete this!");
        setPopupType("confirm");
        setPopupActionType("confirm");
    }

    const deleteingFile = () => {
        setIsOpen(false);
        const document_id = localStorage.getItem("deletDocumentId");
        const name = localStorage.getItem("deletDocumentName")
        const oldValue = localStorage.getItem("deletDocumentValue")
        let request = {
            document_id,
            seller_id: successData.seller_id,
            seller_dealer_id: successData.seller_dealer_id,
            seller_token: successData.seller_token,
            seller_status: `${name}` + " document has been Deleted"

        };
        const deleteFile = API.post('documentDelete/update', request)
        deleteFile.then(response => {
            console.log("====response.data====>", response.data)
            let document = response.data.data;
            //console.log("========>>",document.buyer_doc_type_id);

            if (response.data.success) {
                //getDocuments();
                setIsOpen(true);
                setPopupTitle("Document Delete");
                setPopupMsg("Document Successfully Deleted");
                setPopupType("success");
                setPopupActionType("close");
                setPopupActionValue("ok");
                sellerDocument();

                //getDocuments();
                //setPopupActionPath("/document");
            } else {
                setIsOpen(true);
                setPopupTitle("Document Deleted");
                // setPopupMsg("Document is not Deleted, Please try Again");
                setPopupMsg(response.data.error.err);
                setPopupType("error");
                setPopupActionType("close");
                setPopupActionValue("close");
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }
    const updateFiles = (file, document_id, value, name, oldValue) => {
        // if (file[0].type.includes('.txt') || file[0].type.includes('.doc') || file[0].type.includes('.pdf') || file[0].type.includes('.png') || file[0].type.includes('.jpeg') || file[0].type.includes('.jpg'))
        // {
        //     setType("1");
        // }
        console.log("====value====>", value)
        console.log("====document file====>", file)
        console.log("====document_id====>", document_id)
        if (buyerDocList.map((data) => data.buyer_doc_type_id === value) && !isValidFile(file)) {
            setUpdateType(value);
            console.log("====setType1====>")

        }
        // else if (value =="liability insurance" && !isValidFile(file))
        // {
        //     setUpdateType("2");


        // }
        // else if (value == "company check" && !isValidFile(file))
        // {
        //     setUpdateType("3");


        // }
        // else if (value === "state sales tax" && !isValidFile(file))
        // {
        //     setUpdateType("4");


        // }
        // else if (value === "surety bond" && !isValidFile(file))
        // {
        //     setUpdateType("5");


        // }
        // else if (value === "DMV vehicle" && !isValidFile(file))
        // {
        //     setUpdateType("6");


        // }
        // else if (value === "individual guaranty" && !isValidFile(file))
        // {
        //     setUpdateType("7");


        // }
        // else if (value === "owners and representatives" && !isValidFile(file))
        // {
        //     setUpdateType("8");


        // }
        // else if (value === "bank Authorization" && !isValidFile(file))
        // {
        //     setUpdateType("9");


        // }
        // else if (value === "representatives" && !isValidFile(file))
        // {
        //     setUpdateType("10");


        // }
        // else if (value === "Articles of incorporation" && !isValidFile(file))
        // {
        //     setUpdateType("11");


        // }
        else {

            console.log("====else calli=ng===>")

            let request = {
                document_id: document_id,
                doc_name: [file],
                seller_id: successData.seller_id,
                seller_dealer_id: successData.seller_dealer_id,
                seller_token: successData.seller_token,
                seller_status: `${name}` + " document has been Updated from " + `${oldValue}` + " to " + `${file.name}`,

            };
            const upload = API.post('seller_document/update', request);
            upload.then(response => {
                if (response.data.success) {
                    console.log("====response.data====>", response.data)
                    let document = response.data.data;
                    //console.log("========>>",document.buyer_doc_type_id);
                    if (document[0].seller_doc_type_id === 1) {
                        setDoc1(document[0])
                    }
                    else if (document[0].seller_doc_type_id === 2) {
                        setDoc2(document[0])
                    } else if (document[0].seller_doc_type_id === 3) {
                        setDoc3(document[0])
                    } else if (document[0].seller_doc_type_id === 4) {
                        setDoc4(document[0])
                    } else if (document[0].seller_doc_type_id === 5) {
                        setDoc5(document[0])
                    } else if (document[0].seller_doc_type_id === 6) {
                        setDoc6(document[0])
                    } else if (document[0].seller_doc_type_id === 7) {
                        setDoc7(document[0])
                    } else if (document[0].seller_doc_type_id === 8) {
                        setDoc8(document[0])
                    } else if (document.seller_doc_type_id === 9) {
                        setDoc9(document[0])
                    } else if (document[0].seller_doc_type_id === 10) {
                        setDoc10(document[0])
                    } else if (document[0].seller_doc_type_id === 11) {
                        setDoc11(document[0])
                    }
                    togglePopup()
                    setPopupTitle("Document Upload");
                    setPopupMsg("Document Successfully Updated");
                    setPopupType("success");
                    setPopupActionType("close");
                    setPopupActionValue("ok");
                    sellerDocument();

                    // getDocuments();
                    //setPopupActionPath("/document")
                } else {
                    togglePopup()
                    setPopupTitle("Document Upload");
                    // setPopupMsg("Document is not Updated, Please try Again");
                    setPopupMsg(response.data.error.err);
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }
            })
                .catch(function (error) {
                    if (error.response) {
                        setErrors(error.response.data.error)
                        setErrorFlag(true)
                    }
                });
        }
    }

    const isValidFile = (file) => {
        const fileExtension = file.name.split('.').pop().toLowerCase();

        return [
            "txt",
            "doc",
            "docx",
            "pdf",
            "png",
            "jpg",
            "jpeg"
        ].includes(fileExtension);
    };
    const getFiles = (file, value, data, name) => {
        console.log("====file====>", file)
        console.log("====value====>", value)
        console.log("==== txt ==== ", isValidFile(file))
        setType("")
        console.log("==== condition ==== ", (value == "Dealer license" && !isValidFile(file)))

        if (buyerDocList.map((data) => data.buyer_doc_type_id === value) && !isValidFile(file)) {
            setType(value);
            console.log("====setType1====>")

        }
        // else if (value =="liability insurance" && !isValidFile(file))
        // {
        //     setType("2");


        // }
        // else if (value == "company check" && !isValidFile(file))
        // {
        //     setType("3");


        // }
        // else if (value === "state sales tax" && !isValidFile(file))
        // {
        //     setType("4");


        // }
        // else if (value === "surety bond" && !isValidFile(file))
        // {
        //     setType("5");


        // }
        // else if (value === "DMV vehicle" && !isValidFile(file))
        // {
        //     setType("6");


        // }
        // else if (value === "individual guaranty" && !isValidFile(file))
        // {
        //     setType("7");


        // }
        // else if (value === "owners and representatives" && !isValidFile(file))
        // {
        //     setType("8");


        // }
        // else if (value === "bank Authorization" && !isValidFile(file))
        // {
        //     setType("9");


        // }
        // else if (value === "representatives" && !isValidFile(file))
        // {
        //     setType("10");


        // }
        // else if (value === "Articles of incorporation" && !isValidFile(file))
        // {
        //     setType("11");


        // }
        else {

            console.log("====else calli=ng===>")

            let request = {
                seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

                // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data,


                seller_doc_type_id: value,
                doc_name: [file],
                seller_id: successData.seller_id,
                seller_token: successData.seller_token,
                seller_status: `${file.name}` + " document has been uploaded in " + `${name}`,

            };

            const upload = API.post('seller_document/add', request);
            upload.then(response => {
                if (response.data.success) {
                    console.log("====response.data====>", response.data)
                    let document = response.data.data;
                    //console.log("========>>",document.buyer_doc_type_id);
                    if (document.seller_doc_type_id === 1) {
                        setDoc1(document)
                    }
                    else if (document.seller_doc_type_id === 2) {
                        setDoc2(document)
                    } else if (document.seller_doc_type_id === 3) {
                        setDoc3(document)
                    } else if (document.seller_doc_type_id === 4) {
                        setDoc4(document)
                    } else if (document.seller_doc_type_id === 5) {
                        setDoc5(document)
                    } else if (document.seller_doc_type_id === 6) {
                        setDoc6(document)
                    } else if (document.seller_doc_type_id === 7) {
                        setDoc7(document)
                    } else if (document.seller_doc_type_id === 8) {
                        setDoc8(document)
                    } else if (document.seller_doc_type_id === 9) {
                        setDoc9(document)
                    } else if (document.seller_doc_type_id === 10) {
                        setDoc10(document)
                    } else if (document.seller_doc_type_id === 11) {
                        setDoc11(document)
                    }

                    togglePopup()
                    setPopupTitle("Document Upload");
                    setPopupMsg("Document Successfully Uploaded");
                    setPopupType("success");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                    sellerDocument();

                    //getDocuments();
                    //setPopupActionPath("/document")
                } else {
                    togglePopup()
                    setPopupTitle("Document Upload");
                    // setPopupMsg("Document is not Uploaded, Please try Again");
                    setPopupMsg(response.data.error.err);
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }
            })
                .catch(function (error) {
                    if (error.response) {
                        setErrors(error.response.data.error)
                        setErrorFlag(true)
                    }
                });
        }
    }

    const sellerDocument = (data) => {
        let request = {
            // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data,
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

            seller_id: successData.seller_id,
            seller_token: successData.seller_token,

        };

        API.post("sellerdoclist/condition", request).then(response => {
            console.log("buyerdoclist", response.data.data);
            if (response.data.success === true) {
                setBuyerDocList(response.data.data);

            }
            else {
                setErrors(response.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const handleSellerDetailsName = (e) => {

        setDealerId(e.target.value)
        console.log("=========check seller details name", e.target.value)
        setSelectedSellerDetails(dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
        console.log("=========check", dealerList.filter(data => data.seller_dealer_id == e.target.value))
        const selectedSellerDetails = dealerList.filter(data => data.seller_dealer_id == e.target.value)[0];
        getfileterSellerList(selectedSellerDetails);
        setselectSellerid(selectedSellerDetails.seller_dealer_id)
        setFalgFilter(true)
        dispatch(DealerAction.searchrequest(selectedSellerDetails));
    }

    useEffect(() => {
        if (dealerData !== null) {

            getfileterSellerList(dealerData);
        }
    }, [dealerData])

    const getDealername = (data) => {

        let request = {
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post("dealerNameDynamic/condition", request).then(response => {
            if (response.data.success === true) {


                setDealerList(response.data.data);

            }

            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }


        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const getfileterSellerList = (data, flag) => {

        let request = {
            seller_dealer_id: data.seller_dealer_id,

            seller_id: successData.seller_id,
            seller_token: successData.seller_token
        }
        API.post("sellerdoclistFilter/condition", request).then(response => {
            if (response.data.success === true) {
                setBuyerDocList(response.data.data);

            }

            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }
    const handleFileDownload = async (fileUrl) => {
        const fileName = fileUrl.split('/').pop();
        const fileExtension = fileName.split('.').pop();

        console.log("fileName", fileName);
        console.log("fileName fileExtension", fileExtension);


        try {
            const response = await fetch(fileUrl);
            console.log("fileName response", response);

            if (!response.ok) {
                throw new Error(`Error downloading the file: ${response.status} ${response.statusText}`);
            }

            const contentType = determineContentType(fileExtension);
            console.log("fileName contentType", contentType);

            const blob = await response.blob();
            console.log("fileName blob", blob);

            const url = window.URL.createObjectURL(blob);
            console.log("fileName url", url);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);

            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };

    function determineContentType(fileExtension) {
        switch (fileExtension) {
            case 'jpeg':
            case 'jpg':
                return 'image/jpeg';
            case 'png':
                return 'image/png';
            case 'pdf':
                return 'application/pdf';
            case 'doc':
                return 'application/msword';
            case 'docx':
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            default:
                return 'application/octet-stream';
        }
    }
    function getDocumentType(url) {
        // Extract the file extension
        const extension = url.split('.').pop().toLowerCase();
        console.log("extension", extension)
        return extension;
    }
    const convertToBase64 = (file, callback) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            callback({
                name: file.name,
                type: file.type,
                size: file.size,
                base64: reader.result,
                file: reader
            });
        };

        reader.onerror = (error) => {
            console.error("File reading error:", error);
        };
    };
    return (
        <div>
            <main id="main" className="inner-page">
                {loading ? <Loading /> :

                    <div id="documentspage" className="documentspage">
                        {errorFlag === true ? <PageNotFound error={errors} /> :
                            <div className="container-fluid inner-page-space" >
                                <div className="documentspageblock">
                                    <div class="common-heading mb-2">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div class="back-btn">
                                                    <a class="back-btn-primary" onClick={() => history.push("/carlist")}>
                                                        <i class="bx bx-chevron-left"></i> Back
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div class="title">
                                                    <p class="inner-title">Documents</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div class="title-dropdown">
                                                    <select class="form-control box " id="drop" placeholder="" className={`${dealerData != null ? (dealerData?.color == "pink"
                                                        ? "tableRowPink  form-control box"
                                                        : dealerData?.color == "firered"
                                                            ? "tableRowFireRed  form-control box"
                                                            : dealerData?.color == "green"
                                                                ? "tableRowGreenColor form-control box"
                                                                : dealerData?.color == "darkred"
                                                                    ? "tableRowRed1  form-control box"
                                                                    : " form-control box") :
                                                        (dealerList[0]?.color == "pink"
                                                            ? "tableRowPink  form-control box"
                                                            : dealerList[0]?.color == "firered"
                                                                ? "tableRowFireRed  form-control box"
                                                                : dealerList[0]?.color == "green"
                                                                    ? "tableRowGreenColor form-control box"
                                                                    : dealerList[0]?.color == "darkred"
                                                                        ? "tableRowRed1  form-control box"
                                                                        : " form-control box")
                                                        }`} onChange={handleSellerDetailsName}>
                                                        {dealerData != null ?
                                                            <option value={null} style={{ "display": "none" }}>{dealerData.dealer_name}({dealerData?.seller_dealer_id})</option> :
                                                            <option value={null} style={{ "display": "none" }}>{dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})</option>}
                                                        {dealerList.length > 0 &&
                                                            <>
                                                                {dealerList.map((dealerList, index) => <option className={dealerList?.color == "pink"
                                                                    ? "tableRowPink  user_name"
                                                                    : dealerList?.color == "Silver"
                                                                        ? "tableRowSilver  user_name"
                                                                        : dealerList?.color == "Orange"
                                                                            ? "tableRowOrange  user_name"
                                                                            : dealerList?.color == "Navy blue"
                                                                                ? "tableRowNavyBlue  user_name"
                                                                                : dealerList?.color == "firered"
                                                                                    ? "tableRowFireRed  user_name"
                                                                                    : dealerList?.color == "Purple"
                                                                                        ? "tableRowPurple  user_name"
                                                                                        : dealerList?.color == "Yellow"
                                                                                            ? "tableRowYellow1  user_name"
                                                                                            : dealerList?.color == "green"
                                                                                                ? "tableRowGreenColor user_name"
                                                                                                : dealerList?.color == "blue"
                                                                                                    ? "tableRowBlue  user_name"
                                                                                                    : dealerList?.color == "darkred"
                                                                                                        ? "tableRowRed1  user_name"
                                                                                                        : dealerList?.color == "black"
                                                                                                            ? "tableRowBlack1 user_name"
                                                                                                            : " user_name"} key={dealerList.seller_dealer_id} value={dealerList.seller_dealer_id}  >{dealerList.dealer_name}({dealerList?.seller_dealer_id})</option>)}
                                                            </>
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row content">
                                        <div className="col-lg-4 col-md-12 col-sm-12 accountleftblock">
                                            <ManageAccountLinks />
                                        </div>
                                        <div className="col-lg-8 col-md-12 col-sm-12 documentsrightblock">
                                            <div className="documentspage-inner">
                                                <div className="col-lg-12">
                                                    <div className="row">
                                                        {buyerDocList?.length > 0 ? buyerDocList.map((buyerDocList) =>
                                                            <div className="col-lg-4 col-md-4 mb-3 ">
                                                                {buyerDocList.doc_name == null || buyerDocList.doc_name == undefined || buyerDocList.doc_name == "" ? <div className="docdetails">
                                                                    <h5>{buyerDocList?.seller_doc_type}</h5>
                                                                    <img src={process.env.PUBLIC_URL + "/images/uploadblack.png"} className="img-fluid" alt="" />
                                                                    <p>
                                                                        <div className="upload-btn-wrapper">
                                                                            <a className="btn"> Upload File</a>
                                                                            <input
                                                                                type="file"
                                                                                onChange={(e) => {
                                                                                    const file = e.target.files[0];
                                                                                    if (!file) return;

                                                                                    convertToBase64(file, (base64File) => {
                                                                                        getFiles(
                                                                                            base64File,
                                                                                            buyerDocList.seller_doc_type_id,
                                                                                            dealerData,
                                                                                            buyerDocList.seller_doc_type
                                                                                        );
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </p>
                                                                    {Type === buyerDocList.seller_doc_type_id ? <p className="form-input-error">Only TXT,DOC/DOCX,PDF,JPG,PNG,JPEG file formats can be uploaded</p> : ""}
                                                                </div> :
                                                                    <div className="docdetails">
                                                                        <h5>{buyerDocList.seller_doc_type}</h5>
                                                                        {getDocumentType(buyerDocList.doc_name) == "pdf" ?
                                                                            <a href={buyerDocList.doc_name} target="_blank"><i class="icofont-file-pdf" style={{ color: "#BD062C", fontSize: "40px" }}></i> </a> :
                                                                            (getDocumentType(buyerDocList.doc_name) == "txt" ?
                                                                                <a href={buyerDocList.doc_name} target="_blank"><i class="icofont-file-text" style={{ color: "#BD062C", fontSize: "40px" }}></i></a> :
                                                                                getDocumentType(buyerDocList.doc_name) == "docx" || getDocumentType(buyerDocList.doc_name) == "doc" ? <a href={buyerDocList.doc_name} target="_blank">
                                                                                    <i class="icofont-file-document" style={{ color: "#BD062C", fontSize: "40px" }}></i> </a> :
                                                                                    <a href={buyerDocList.doc_name} target="_blank"><i class="icofont-image" style={{ color: "#BD062C", fontSize: "40px" }}></i></a>
                                                                            )
                                                                        }
                                                                        <div><a href={buyerDocList.doc_name} target="_blank">{buyerDocList.doc_name.split("_")[1]}</a></div>
                                                                        <p>
                                                                            <div className="upload-btn-wrapper updateFile">
                                                                                <a className="btn"> Update</a>
                                                                                <input
                                                                                    type="file"
                                                                                    onChange={(e) => {
                                                                                        const file = e.target.files[0];
                                                                                        if (!file) return;

                                                                                        convertToBase64(file, (base64File) => {
                                                                                            updateFiles(
                                                                                                base64File,
                                                                                                buyerDocList.document_id,
                                                                                                buyerDocList.seller_doc_type_id,
                                                                                                buyerDocList.seller_doc_type,
                                                                                                buyerDocList.doc_name.split("_")[1]
                                                                                            );
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <a className="btn" onClick={() => handleFileDownload(buyerDocList.doc_name)}>Download</a>

                                                                            <a className="btn deleteFile" onClick={(e) => deleteFileConfirmation(buyerDocList.document_id, buyerDocList.seller_doc_type_id, buyerDocList.seller_doc_type, buyerDocList.doc_name.split('_')[1])}> Delete</a>
                                                                            {UpdateType === buyerDocList.seller_doc_type_id ? <p className="form-input-error">Only TXT,DOC/DOCX,PDF,JPG,PNG,JPEG file formats can be uploaded</p> : ""}
                                                                        </p>
                                                                    </div>}
                                                            </div>
                                                        ) : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>}
                <section id="playstoreBlock" className="playstoreBlock">
                    <div className="container">
                        <div className="row content">
                            <div className="col-lg-12">
                                <img src={appstore} />
                                <img src={googleplay} />
                            </div>
                        </div>
                    </div>
                </section>
                {isOpen &&
                    <CommonPopup
                        handleClose={togglePopup}
                        popupTitle={popupTitle}
                        popupMsg={popupMsg}
                        popupType={popupType}
                        popupActionType={popupActionType}
                        popupActionValue={popupActionValue}
                        popupActionPath={popupActionPath}
                        Confirmation={deleteingFile}
                    />}
            </main>
        </div>
    )
}
export default Document;